import React from "react";
import FreightItemFormType from "../common/enum/FreightItemFormType";
import FreightBulkMeasureType from "../common/enum/FreightBulkMeasureType";

interface ConsignmentFreightTableProps {
    freight: Array<CustomerAPIFreightBulk | CustomerAPIFreightItem>
}

const ConsignmentFreightTable = (props: ConsignmentFreightTableProps) => {

    const formatDescription = (freight: CustomerAPIFreight) => {
        let description = "";
        if (freight.product && freight.product.description) {
            if (description) {
                description += " ";
            }
            description += freight.product.description;
        }
        return (
            <>
                {description}
                {freight.trackingCode && <span style={{fontSize: '70%'}}><br />Tracking code: {freight.trackingCode}</span>}
                {freight.wasteRecordId && <span style={{fontSize: '70%'}}><br />EPA Waste record Id: {freight.wasteRecordId}</span>}
            </>
        );
    };

    const renderFreightItem = (freight: CustomerAPIFreightItem | CustomerAPIFreightBulk) => {
        switch (freight.type) {
            case "ITEM": {
                const freightItem = freight as CustomerAPIFreightItem;
                const form = FreightItemFormType.valueOf(freightItem.form);
                return (
                    <>{freightItem.quantity}&nbsp;
                        <span style={{fontSize: '70%'}}>{form && form.description}</span>
                    </>
                );
            }
            case "BULK": {
                const freightBulk = freight as CustomerAPIFreightBulk;
                const bulkMeasure = FreightBulkMeasureType.valueOf(freightBulk.measure);
                return (
                    <>{(bulkMeasure && bulkMeasure.showNetQty() && freightBulk.netQty) ? freightBulk.netQty : freightBulk.orderedQty}&nbsp;
                        <span style={{fontSize: '70%'}}>{bulkMeasure && bulkMeasure.description}</span>
                    </>
                );
            }
            default:
                throw new Error("Unhandled freight type " + freight.type);
        }
    }

    if (props.freight.length < 1) {
        return null;
    }

    return (
        <>
            <div className="d-xl-none"><strong>Freight</strong><br /></div>

            {props.freight.length > 0 &&
                <div className="d-none d-lg-block">
                    <div className="row">
                        <div className="col-md-7">
                            <strong>Product</strong>
                        </div>
                        <div className="col-md-5">
                            <strong>Quantity</strong>
                        </div>
                    </div>
                    <hr />
                </div>
            }

            {props.freight.map(freight => {
                return (
                    <div className="row" key={freight.id}>
                        <div className="col-md-7">
                            {formatDescription(freight)}
                        </div>
                        <div className="col-md-5">
                            {renderFreightItem(freight)}
                        </div>
                    </div>
                )
            })}
        </>
    )
}

export default ConsignmentFreightTable;
